import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { Routes } from "../../../../../AppRoutes";
import { ITRepairInfoService } from "../../../../../services/it-repair/itRepairInfo.service";

export const useCreateRTR = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => ITRepairInfoService.addITRepairInfo(body),
  });

  const createRTRequest = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(res: any) {
        queryClient.invalidateQueries({ queryKey: ["repair-tools-requests"] });
        history.push(Routes.repairITToolDetailPage.path.replace(":id", res.id));
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(res);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };

  return { mutate, createRTRequest, restMutation };
};
